import { Button, Modal, Table, Upload } from 'antd';
import API from 'API';
import React, { useCallback, useMemo, useState } from 'react'
import { UploadOutlined } from '@ant-design/icons';
import toastr from 'toastr';
import { colorSet } from 'const';
import Papa from 'papaparse';
import { createFormData, downloadFile } from 'general_function';

export default function ShowCSVFile({ title, open, submitPath, addOnPayLoad={}, mandatoryHeader, onCancel, onDone }) {
    const [dataSource, setDataSource] = useState([]);
    const [columns, setColumns] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [submitting, setSubmitting] = useState(false);

    const handleBeforeUpload = useCallback((file) => {
        setFileList([file]);
        const reader = new FileReader();
        reader.onload = (e) => {
            const csvText = e.target.result;

            Papa.parse(csvText, {
                header: true,
                skipEmptyLines: true,
                complete: (results) => {
                    const parsedData = results.data;
                    const dynamicColumns = Object.keys(parsedData[0] || {}).map((key) => ({
                        title: key,
                        dataIndex: key,
                        key: key,
                    }));

                    const dataWithKeys = parsedData.map((row, index) => ({
                        ...row,
                        key: index,
                    }));

                    setColumns(dynamicColumns);
                    setDataSource(dataWithKeys);
                },
                error: (error) => {
                    console.error('Lỗi đọc file CSV: ' + error.message);
                },
            });
        };

        reader.readAsText(file);

        return false;
    }, [])

    const checkFormat = useMemo(() => {
        if (fileList.length === 0) return null;
        const columnTitle = columns.map(item => item.title);
        const missingHeader = [];
        for (const header of mandatoryHeader) {
            if (!columnTitle.includes(header)) {
                missingHeader.push(header);
            }
        }
        if (missingHeader.length === 0) return null;
        return <span style={{ color: colorSet["low"] }}>
            File không đúng định dạng, thiếu cột <b>{missingHeader.join(", ")}</b>.
        </span>
    }, [columns, fileList, mandatoryHeader])

    const submitFile = useCallback(() => {
        if (submitting) {
            toastr.info("Đang xử lý file");
            return;
        }
        if (fileList.length === 0) {
            toastr.error("Chưa chọn file");
            return;
        }
        if (checkFormat !== null) {
            toastr.error("File không đúng định dạng");
            return;
        }
        setSubmitting(true);
        const formData = createFormData({file: fileList[0], ...addOnPayLoad});
        API.post(submitPath, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then(res => {
            onDone && onDone(res);
            toastr.success("Xử lý file thành công!");
        })
        .catch(error => {
            console.log(error);
        })
        .finally(() => {
            setSubmitting(false);
        })
    }, [submitting, fileList, checkFormat, addOnPayLoad, onDone, submitPath])

    return <Modal
        open={open}
        onCancel={() => {
            if (submitting) {
                return;
            }
            onCancel && onCancel();
        }}
        footer={[
            !submitting && <Button key="close" onClick={() => {
                onCancel && onCancel();
            }}>
                Đóng
            </Button>,
            <Button key="submit" type='primary' disabled={submitting} loading={submitting} onClick={submitFile}>
                Nộp file
            </Button>
        ]}
        title={title}
    >
        <Button type='primary' style={{ marginRight: 3 }} onClick={() => {
            API.get(submitPath, { responseType: 'blob' })
            .then(async res =>  {
                const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
                const url = window.URL.createObjectURL(blob);
                downloadFile(url, "submit_score_template.csv");
            })
        }}>
            Tải file mẫu
        </Button>
        <Upload fileList={fileList} name='file' accept=".csv" maxCount={1} beforeUpload={handleBeforeUpload} onRemove={() => {
            if (submitting) {
                toastr.info("Đang xử lý file, không thể xoá");
                return;
            }
            setFileList([])
        }}>
            <Button icon={<UploadOutlined />} loading={submitting} disabled={submitting}>Chọn file</Button>
        </Upload>
        {checkFormat}
        {fileList.length > 0 && <div style={{ maxHeight: 400, overflowY: "auto" }}><Table
            dataSource={dataSource}
            columns={columns}
            pagination={false}
        /></div>}
    </Modal>
}
